import { factory, Box, Grid, GridColumn, Flex, Typography, omitText } from '@kohler-dsm-library/kohler-core';
import clsx from 'clsx';
import React from 'react';
import { LanguageMenu } from '../LanguageMenu/LanguageMenu.mjs';
import { LoginMenu } from '../LoginMenu/LoginMenu.mjs';
import { StoreMenu } from '../StoreMenu/StoreMenu.mjs';
import { UtilityLinks } from '../UtilityLinks/UtilityLinks.mjs';
import classes from './UtilityBar.module.css.mjs';

const UtilityBar = factory((props, ref) => {
  const {
    brands,
    mod,
    loginMenu,
    storeMenu,
    languageMenu,
    menuOpen,
    setMenuOpen,
    favoritesCTA,
    cartBadgeCTA,
    userCTA,
    isLoggedIn,
    languagePicker,
    locationPickerCTA,
    userName,
    utilityLinksMobile,
    userCTAMobile,
    setIsOpenMobileMenu,
    ...rest
  } = props;
  const utilityLinks = {
    favoritesCTA,
    cartBadgeCTA,
    userCTA,
    isLoggedIn,
    languagePicker,
    locationPickerCTA,
    userName,
    utilityLinksMobile,
    userCTAMobile
  };
  return /* @__PURE__ */ React.createElement(Box, { className: classes.utilityBar, mod, ref, ...rest }, /* @__PURE__ */ React.createElement(Grid, null, /* @__PURE__ */ React.createElement(GridColumn, { className: classes.utilityBarContent }, brands && /* @__PURE__ */ React.createElement(Flex, { component: "ul", className: classes.utilityBrands }, brands.map((brand) => {
    const { isActive, ...brandProps } = brand;
    return /* @__PURE__ */ React.createElement(Box, { component: "li", key: brand.text }, /* @__PURE__ */ React.createElement(
      Typography,
      {
        size: "navigation-brand-switcher",
        component: "a",
        target: "_blank",
        ...omitText(brandProps),
        className: clsx(classes.utilityBrand, isActive && classes.utilityBrandActive)
      },
      brand.text
    ));
  })), /* @__PURE__ */ React.createElement(UtilityLinks, { ...utilityLinks, menuType: menuOpen, className: classes.utilityLinksWrapper }))), menuOpen && /* @__PURE__ */ React.createElement(Box, { className: classes.menuPositionWrapper }, menuOpen === "user" && /* @__PURE__ */ React.createElement(LoginMenu, { ...loginMenu, setMenuOpen, setIsOpenMobileMenu }), menuOpen === "language" && languageMenu && /* @__PURE__ */ React.createElement(LanguageMenu, { ...languageMenu, setMenuOpen, setIsOpenMobileMenu }), menuOpen === "store" && storeMenu && /* @__PURE__ */ React.createElement(StoreMenu, { ...storeMenu, setMenuOpen, setIsOpenMobileMenu }), /* @__PURE__ */ React.createElement(Box, { className: classes.menuPositionOverlay, onClick: () => setMenuOpen?.(null) })));
});

export { UtilityBar };
